module.exports = __webpack_public_path__ + "images/emoji/raising_hand.0df991b27e42d5c72efb.png";